import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import LeftFilterBox from "../../LeftFilterBox/LeftFilterBox";
import { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { Button } from "react-bootstrap";
import Select from "react-select";
import Alert from "react-bootstrap/Alert";

import { useSelector, useDispatch } from "react-redux";

import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import Modal from "react-bootstrap/Modal";

import CreateTab from "./components/CreateTab";
import EditTab from "./components/EditTab";
import HistoryTab from "./components/HistoryTab";

import MobileUnitApi from "../../../api/MobileUnitApi";
import CommonAPI from "../../../api/CommonApi";

import Cookies from "js-cookie";
import { equipmentsPortfolioActions } from "../../../store/equipmentsPortfolioSlice/equipmentPortfolioSlice";

export default function MobileUnit() {
    const [activeTabKey, setActiveTabKey] = useState("create");

    // extarcting from redux slice
    const { selectedMobileUnit } = useSelector((state) => state.equipmentsPortfolio);
    const portalToken = Cookies.get("portalSession");
    const token = Cookies.get("Session");

    const dispatch = useDispatch();

    const [showDeactivateModal, setShowDeactivateModal] = useState(false);
    const [alert, setAlert] = useState({
        color: "primary",
        text: "",
        show: false,
    });
    const [otp, setOtp] = useState("");
    const [verifyToken, setVerifyToken] = useState("");

    const [isDeactivateDisabled, setIsDeactivateDisabled] = useState(true);

    useEffect(() => {
        updateMobileUnitList();
    }, []);

    useEffect(() => {
        if (selectedMobileUnit == null || selectedMobileUnit.location_node_id == null) {
            setIsDeactivateDisabled(true);
        } else {
            setIsDeactivateDisabled(false);
        }
    }, [selectedMobileUnit]);

    const updateMobileUnitList = () => {
        MobileUnitApi.getMobileUnitList(portalToken)
            .then((resp) => {
                if (resp.status == 200) {
                    const mobileUnitList = parsePortalResponse(resp.data.data);
                    dispatch(equipmentsPortfolioActions.setMobileUnitList(mobileUnitList));
                }
            })
            .catch((err) => {});
    };

    const onSelectTab = (key) => {
        setActiveTabKey(key);
    };

    const isOtpValid = (val) => {
        const re = /[^0-9]/;
        if (re.test(val)) return false;
        if (val.length > 8) return false;
        return true;
    };

    const onOtpUpdate = (event) => {
        const val = event.target.value;
        const valid = isOtpValid(val);
        if (valid) {
            setOtp(val);
        }
        return;
    };

    const onDeactivate = () => {
        setIsDeactivateDisabled(false);
        setShowDeactivateModal(true);
        setOtp("");
        setVerifyToken("");

        MobileUnitApi.unassignLocation(
            portalToken,
            selectedMobileUnit.customer_id,
            selectedMobileUnit.facility_id,
            selectedMobileUnit.location_id,
            selectedMobileUnit.node_sn,
        )
            .then((resp) => {
                if (resp.status == 200 && resp.data.data?.token) {
                    setVerifyToken(resp.data.data.token);
                } else {
                    setAlert({
                        color: "danger",
                        text: "Error Unassigning Location. Try Again Later",
                        show: true,
                    });
                    setShowDeactivateModal(false);
                }
            })
            .catch((err) => {
                setAlert({
                    color: "danger",
                    text: "Error Unassigning Location. Try Again Later",
                    show: true,
                });
                setShowDeactivateModal(false);
            });
    };

    const onConfirm = () => {
        setIsDeactivateDisabled(true);
        MobileUnitApi.confirmUnassign(
            portalToken,
            selectedMobileUnit.customer_id,
            selectedMobileUnit.facility_id,
            selectedMobileUnit.location_id,
            selectedMobileUnit.node_sn,
            otp,
            verifyToken,
        )
            .then((resp) => {
                if (resp.status == 200) {
                    setAlert({
                        color: "success",
                        text: "Unassign Successful. Analytics Will Update In a Few Minutes.",
                        show: true,
                    });
                    setIsDeactivateDisabled(true);
                    refreshEquipment();
                } else {
                    setAlert({
                        color: "danger",
                        text: "Error Unassigning Location. Try Again Later",
                        show: true,
                    });
                    setIsDeactivateDisabled(false);
                }
                setShowDeactivateModal(false);
                setOtp("");
                setVerifyToken("");
            })
            .catch((err) => {
                setAlert({
                    color: "danger",
                    text: "Error Unassigning Location. Try Again Later",
                    show: true,
                });
                setShowDeactivateModal(false);
                setIsDeactivateDisabled(false);
                setOtp("");
                setVerifyToken("");
            });
    };
    const onCancel = () => {
        setShowDeactivateModal(false);
        setIsDeactivateDisabled(false);
        setOtp("");
        setVerifyToken("");
    };

    const updateEquipmentPortfolio = () => {
        CommonAPI.getCustomerPortfolio(token).then((response) => {
            dispatch(equipmentsPortfolioActions.setEquipmentPortfolio(response.data.content));
        });
    };

    const refreshEquipment = () => {
        updateMobileUnitList();
        setTimeout(updateEquipmentPortfolio, 60 * 1000); // Refresh Equipment portfolio after a minute to sync w/ admin
    };

    return (
        <div className="mobileUnit">
            <Card>
                <Card.Body>
                    <Row>
                        <Col className="col-4">
                            <LeftFilterBox />
                        </Col>
                        <Col>
                            <Card>
                                <Card.Header className="mobileUnitHeader">
                                    <div>Node SN: {selectedMobileUnit?.node_sn ?? "Not Selected\t"}</div>
                                    <div>Current Location: {selectedMobileUnit?.location_name ?? "Unassigned"}</div>
                                    <Button disabled={isDeactivateDisabled} onClick={onDeactivate} variant="danger">
                                        Unassign
                                    </Button>
                                </Card.Header>
                                <Card.Body>
                                    <Alert
                                        variant={alert.color}
                                        show={alert.show}
                                        dismissible
                                        onClose={() => setAlert({ color: "", text: "", show: false })}
                                    >
                                        {alert.text}
                                    </Alert>
                                    <Tabs
                                        defaultActiveKey="create"
                                        activeKey={activeTabKey}
                                        variant="pills"
                                        onSelect={onSelectTab}
                                    >
                                        {/* **************************************** Create Location Tabs **************************************** */}
                                        <Tab eventKey="create" title="Create">
                                            <CreateTab refreshEquipment={refreshEquipment} />
                                        </Tab>
                                        <Tab eventKey="edit" title="Edit">
                                            <EditTab refreshEquipment={refreshEquipment} />
                                        </Tab>
                                        {/* <Tab eventKey="history" title="History">
                                            <HistoryTab />
                                        </Tab> */}
                                    </Tabs>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            <Modal
                show={showDeactivateModal}
                size="lg"
                centered
                onHide={() => {
                    setShowDeactivateModal(false);
                }}
            >
                <Modal.Header>
                    <h4>Confirm Location Deactivation</h4>
                </Modal.Header>
                <Modal.Body>
                    <Form.Control
                        value={otp}
                        onChange={(e) => onOtpUpdate(e)}
                        // type="number"
                        // disabled={disabled}
                        // isInvalid={!isDurationValid(duration)}
                        placeholder="OTP Code. Ex: 12345678"
                        disabled={isDeactivateDisabled}
                    />
                    A One Time Password Has Been Sent To Your Email.
                    <br />
                    The Node Will Stop Recording Data For This Location. To Resume Data Recording, a New Location Will
                    Need To Be Created
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onCancel}>
                        Cancel
                    </Button>
                    <Button onClick={onConfirm}>Confirm</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

const parsePortalResponse = (data) => {
    return data.map((eq) => {
        return {
            customer_id: eq.customerId,
            customer_name: eq.customerName,
            division: eq.division,
            facility_id: eq.facilityId,
            facility_name: eq.facilityName,
            location_name: eq.locationName,
            location_node_id: eq.locationNodeId,
            node_sn: eq.serialNumber,
            location_id: eq.locationId,
            product_type: "Node",
            timezone: eq.timezone,
            np_voltage: eq.npVoltage ?? "",
            np_current: eq.npCurrent ?? "",
            np_sf: eq.npServiceFactor ?? "",
            np_frequency: eq.npLineFrequency ?? "",
            np_rpm: eq.npRpm ?? "",
            np_hp: eq.npHp ?? "",
            poles: eq.npPoles ?? "",
            rotorBars: eq.npRotorBars ?? "",
            equipment_type: eq.equipmentType,
            starter: eq.starter,
            v_tap_location: eq.voltageTapLocation,
            ct_location: eq.ctLocation,
            label: `${eq.locationName ?? "Unassigned"} - Mobile Unit - SN:${eq.serialNumber}`,
            value: eq.locationNodeId,
        };
    });
};
